import { SessionContext } from './auth';

export type SessionCookie = SessionContext;

export const SESSION_COOKIE = 'session';

export type UICookie = {
  promptSuppressShowInfo?: boolean;
};

export const UI_COOKIE = 'ui';